import { HSA, LSA } from '#common/spending-accounts.ts';

export const isTypeHsaOrLsa = (cardType: string | undefined) =>
  cardType === LSA || cardType === HSA;
